import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Stack, Typography } from '@mui/material';

import env from '@config/runtimeConfig';

import { AtsLogo } from './';

const AppLogo: FC = () => {
  const { t } = useTranslation();

  return (
    <Stack alignItems='center' mb={4} mt={2} mx='auto' spacing={0.5} width='min-content'>
      <AtsLogo width={1} />

      <Typography noWrap variant='h1'>
        {t('appName')}
      </Typography>

      <Divider flexItem>
        <Typography
          color='text.secondary'
          component='span'
          fontWeight={500}
          textTransform='uppercase'
          variant='h4'
        >
          {t('env', { context: env })}
        </Typography>
      </Divider>
    </Stack>
  );
};

export default AppLogo;
